import { TagPicker } from 'rsuite';
import Select from './Select';
import { jsx as _jsx } from "react/jsx-runtime";
const MultiSelect = props => { return /*#__PURE__*/ _jsx(Select, Object.assign(Object.assign({}, props), { Component: TagPicker })); };
export default MultiSelect;
